import React, { useEffect, useMemo } from "react";
import Button from "../../../components/FormElement/Button";
import { PlusOutlined } from "@ant-design/icons";
import Form from "./Form";
import CustomPagination from "../../../components/FormElement/Pagination";
import { useShowModal, useHideModal } from "../../../hooks";
import DeleteModal from "../../../components/DeleteModal";
import service from "../../../services/feedback";
import { useState } from "react";
import { useShowAlert } from "../../../hooks/useAlerts";
import { Header, Wrapper, CardWrapper } from "./style";
import FeedbackCard from "../../../components/Cards/FeedbackCard";
import Spinner from "../../../components/Spinner/FullScreen";

function Dashboard() {
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}`,
    [pageQuery, limitQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item, idx) => ({
        ...item,
        img: item.photo,
        index: pagination.page * pagination.limit - pagination.limit + idx + 1,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  const handleShowModal = () => {
    showBlured({
      title: "Ma'lumotlarni kiriting",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form refreshData={fetchData} />,
    });
  };

  const handleUpdate = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form data={data.id} refreshData={fetchData} />,
    });
  };

  const onDelete = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    showBlured({
      title: "",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <DeleteModal onClick={() => onDelete(id)} />,
    });
  };

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };

  if (loading) return <Spinner />;
  return (
    <Wrapper>
      <Header>
        <Button
          icon={<PlusOutlined />}
          text="Qo'shish"
          onClick={handleShowModal}
        />
      </Header>
      <CardWrapper>
        {data.map((item) => {
          return (
            <FeedbackCard
              key={item.id}
              data={item}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
            />
          );
        })}
      </CardWrapper>

      {total > 10 && (
        <CustomPagination
          align="end"
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </Wrapper>
  );
}

export default Dashboard;
